import { useQuery } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'

export const GET_CUSTOMER_REQUESTS_KEY = 'get-customer-requests'

export const useGetCustomerRequests = () => {
  return useQuery({
    queryKey: [GET_CUSTOMER_REQUESTS_KEY] as const,
    queryFn: async () => {
      const { data, error } = await supabaseApi.from('customer_requests').select('*, customers(*)')

      if (error) throw error
      return data
    },
  })
}
